import React from 'react';
import { IRequestStateMeta } from '../../reducers/requestsState';
import { InteractionName } from '../../types/InteractionName';
import { fedopsLogger } from '../../utils/fedopsLogger';
import { CardsListConnect } from './view.connect';

export interface ICardsListControllerConnectedProps {
  markCardPrimaryState: IRequestStateMeta;
  deleteCardState: IRequestStateMeta;
  deletePrimaryCardState: IRequestStateMeta;
}

export class CardsListController extends React.Component<ICardsListControllerConnectedProps> {
  componentDidUpdate(prevProps: ICardsListControllerConnectedProps) {
    if (prevProps.markCardPrimaryState.loading && this.props.markCardPrimaryState.success) {
      fedopsLogger.interactionEnded(InteractionName.MARK_CARD_AS_PRIMARY);
    }

    if (
      (prevProps.deleteCardState.loading && this.props.deleteCardState.success) ||
      (prevProps.deletePrimaryCardState.loading && this.props.deletePrimaryCardState.success)
    ) {
      fedopsLogger.interactionEnded(InteractionName.DELETE_CARD);
    }
  }

  render() {
    return <CardsListConnect />;
  }
}
